import toast from 'react-hot-toast';
import useApi from '../useApi';
import { IToggleRTMTimeLogRes } from './index.type';

const useDeleteRtmTimeLog = ({ RTMTimeLogId }: { RTMTimeLogId?: string }) => {
  const { loading: deleteRTMTimeLogLoading, makeApiCall } = useApi({
    url: `/RTM/deleteTimeLog/${RTMTimeLogId}`,
    method: 'PATCH',
  });

  const deleteRTMTimeLog = async () => {
    const { response, error } = await makeApiCall<undefined, IToggleRTMTimeLogRes>();
    
    if (response?.status === 'success') {
      toast.success('RTM Time Log deleted successfully'); 
      return { status: response.status, data: response.data };
    }
    
    if (error) {
      toast.error('Something went wrong while deleting RTM Time Log. Please try again later');
      return { status: 'fail' };
    }
    
    return { status: 'fail' }; 
  };

  return {
    deleteRTMTimeLogLoading,
    deleteRTMTimeLog,
  };
};

export default useDeleteRtmTimeLog;
